import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import InputStore from '../InputStore';
import FlagStore from '../FlagStore';
import { PolicyModalSectionProps } from './PolicyModalStore';

const DEFAULT_VALUES = {
    name: '',
    description: '',
    status: 'ENABLED',
    isDefault: false,
};

export default class PolicyModalHeaderStore {
    static PropType = PropTypes.shape({
        name: InputStore.PropType.isRequired,
        description: InputStore.PropType.isRequired,
        status: FlagStore.PropType,
        noStatusField: PropTypes.bool,

        ...PolicyModalSectionProps,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class PolicyModalHeaderStore */{
            name: new InputStore(),
            description: new InputStore(),
            status: !data.noStatusField ? new FlagStore() : null,
            noStatusField: false,

            originalValue: {},
        }, data);

        this.name.setValidator(() => !!this.name.value.length);
    }

    resetToDefaults = action(() => {
        this.originalValue = Object.assign({}, DEFAULT_VALUES);
        this.isDefault = DEFAULT_VALUES.isDefault;
        this.name.setValue(DEFAULT_VALUES.name);
        this.name.setTouched(false);
        this.description.setValue(DEFAULT_VALUES.description);

        if (this.noStatusField) {
            delete this.status;
        } else {
            this.status = new FlagStore(DEFAULT_VALUES.status === 'ENABLED');
        }
    });

    setValue = action((v) => {
        const {
            name = DEFAULT_VALUES.name,
            description = DEFAULT_VALUES.description,
            status = DEFAULT_VALUES.status,
            isDefault = DEFAULT_VALUES.isDefault
        } = v || {};

        const value = {
            name,
            description,
            status,
            isDefault
        };

        this.originalValue = value;
        this.isDefault = value.isDefault;
        this.name.setValue(value.name);
        this.description.setValue(value.description);

        if (this.noStatusField) {
            delete this.status;
        } else {
            this.status = new FlagStore(value.status === 'ENABLED');
        }
    });

    getValue = () => ({
        name: this.name.value,
        description: this.description.value,
        ...(this.noStatusField || !this.status ? {} : { status: this.status.isTrue ? 'ENABLED' : 'DISABLED' })
    });

    onNameFieldFocusChange = () =>
        this.name.setTouched(true);

    hasChanged = () => !this.name.equals(this.originalValue.name || '') ||
        !this.description.equals(this.originalValue.description || '') ||
        (!this.noStatusField && !(this.getValue().status === this.originalValue.status));

    get isValid() {
        return this.name.isValid;
    }
}
